var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 332,
    viewBox: "0 0 266 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37818e-06 89.9998V295C-0.00131202 299.765 0.936139 304.485 2.75867 308.888C4.5812 313.291 7.25316 317.293 10.6221 320.664C13.991 324.034 17.9908 326.708 22.3932 328.533C26.7956 330.358 31.5144 331.298 36.28 331.3H228.8C238.427 331.3 247.66 327.475 254.468 320.668C261.276 313.86 265.1 304.627 265.1 295V36.3097C265.1 26.6823 261.276 17.4493 254.468 10.6417C247.66 3.83415 238.427 0.00976562 228.8 0.00976562H90.02L18.8401 71.1597L1.37818e-06 89.9998Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9998L18.8401 71.1597L90.02 0.00976562H228.8C238.427 0.00976563 247.66 3.83415 254.468 10.6417C261.276 17.4493 265.1 26.6823 265.1 36.3097V120.67H0V89.9998Z",
    fill: "#9C519B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0078125 90.0002L44.4279 99.8102C53.8575 101.757 63.6743 99.8788 71.7194 94.5886C79.7644 89.2984 85.3788 81.0294 87.3279 71.6002L89.1779 61.4102C88.5919 64.2172 87.6615 66.9411 86.4078 69.5201C83.4358 75.6579 78.7949 80.8344 73.0168 84.4565C67.2388 88.0787 60.5573 90 53.7378 90.0002H0.0078125Z",
    fill: "#D7D7D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0078125 90H53.7378C60.5573 89.9997 67.2388 88.0784 73.0168 84.4563C78.7949 80.8342 83.4358 75.6577 86.4078 69.5199C87.6615 66.9409 88.5919 64.217 89.1779 61.4099C89.7445 58.8761 90.0229 56.2863 90.0078 53.6899V0L18.8379 71.1599L0.0078125 90Z",
    fill: "#EFEFEF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.553 148.822L178.988 131.257L161.424 148.822L178.988 166.386L196.553 148.822Z",
    fill: "#9C519B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.565 183.952L179 166.388L161.435 183.952L179 201.517L196.565 183.952Z",
    fill: "#9C519B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.432 183.952L143.867 166.388L126.303 183.952L143.867 201.517L161.432 183.952Z",
    fill: "#9C519B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.424 219.09L143.859 201.525L126.295 219.09L143.859 236.654L161.424 219.09Z",
    fill: "#9C519B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.287 219.082L108.723 201.518L91.1581 219.082L108.723 236.647L126.287 219.082Z",
    fill: "#9C519B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4414 227.81L30.4414 279.81L65.5514 314.95L117.551 262.95L82.4414 227.81ZM83.1614 279.81L65.5514 262.22L83.1213 244.65L100.691 262.22L83.1614 279.81Z",
    fill: "#9C519B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRar);
export default __webpack_public_path__ + "static/media/rar.0d09af115807d5dc25b6bd0bd24fa2d2.svg";
export { ForwardRef as ReactComponent };